export default __webpack_public_path__ + "static/media/psLogo1.e70b528a.svg";